<template>
	<div class="redirect">
		<div id="demo-content">
      <div id="loader-wrapper">
        <div id="loader"></div>
        <div class="loader-section section-left"></div>
        <div class="loader-section section-right"></div>      
      </div>
			<div id="content"> 
  			<div class="transaction-container" :style="{'backgroundColor': color_letra}">
          <!--Status transacción confirmada-->
          <div class="transaction-intern-div" v-if="status == 'APROBADA'">
            <div class="transaction-circle-status">
              <i class="fas fa-check"></i>
            </div>
            <div class="transaction-container-detail">
              <div class="options-back-div">
                <a type="button" :href="dominio+uri"><i class="fas fa-long-arrow-alt-left"></i></a>
              </div>
              <div class="transaction-status-name">
                <h4>TRANSACIÓN {{status}}</h4>
              </div>
              <div class="detail-lines">
                <i class="fas fa-circle"></i>
                <hr>
                <i class="fas fa-circle"></i>
              </div>
              <div class="transaction-company-message">
                <h4>{{ nameCompanie }}</h4>
                <h5>Tu transacción fue enviada exitosamente</h5>
              </div>
              <div class="transaction-button">
                <a type="button" :href="messageWapp" class="boton-send"><i class="fab fa-whatsapp"></i> Enviar a WhatsApp</a>
              </div>
            </div>
          </div>

          <!--status transaccion cancelada-->
          <div class="transaction-intern-div" v-if="(status == 'RECHAZADA' || status == 'ANULADA' || status == 'ERROR')">
            <div class="transaction-circle-status2">
              <i class="fas fa-times"></i>
            </div>
            <div class="transaction-container-detail">
              <div class="options-back-div">
                <i class="fas fa-long-arrow-alt-left"></i>
              </div>
              <div class="transaction-status-name2">
                <h4>TRANSACIÓN {{status}}</h4>
              </div>
              <div class="detail-lines">
                <i class="fas fa-circle"></i>
                <hr>
                <i class="fas fa-circle"></i>
              </div>
              <div class="transaction-company-message">
                <h4>{{ nameCompanie }}</h4>
                <h5>Tu transacción no pudo ser completada</h5>
              </div>
              <div class="transaction-button">
                <a type="button" :href="dominio+uri" class="boton-send2"><i class="fas fa-long-arrow-alt-left"></i> Volver a la tienda</a>
              </div>
            </div>
          </div>

          <!--Status transacción a la espera de confirmacion-->
          <div class="transaction-intern-div" v-if="status == 'PENDIENTE'">
            <div class="transaction-circle-status3">
              <i class="far fa-clock"></i>
            </div>
            <div class="transaction-container-detail">
              <div class="options-back-div">
                <i class="fas fa-long-arrow-alt-left"></i>
              </div>
              <div class="transaction-status-name3">
                <h4>TRANSACIÓN {{status}}</h4>
              </div>
              <div class="detail-lines">
                <i class="fas fa-circle"></i>
                <hr>
                <i class="fas fa-circle"></i>
              </div>
              <div class="transaction-company-message">
                <h4>{{ nameCompanie }}</h4>
                <h5>Tu transacción está a la espera de confirmación</h5>
              </div>
              <div class="transaction-button">
                <a type="button" @click="setup()" class="boton-send3"> Verificar transacción</a>
              </div>
            </div>
          </div>
        </div>
			</div>
		</div>
	</div>
</template>
<style scoped>

  @media only screen and (min-width: 992px) and (max-width: 1920px){
    .transaction-intern-div{
      width: 30% !important;
      margin: 0 auto;
    }
  }

  .transaction-container{
      width: 100%;
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .transaction-intern-div{
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      text-align: center;
      flex-wrap: wrap;
    }

    .transaction-circle-status{
      width: 110px;
      height: 110px;
      border-radius: 50%;
      border: 7px solid #fff;
      background: #32A85B;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 5000000;
    }

    .transaction-circle-status i{
      font-size: 30px;
      color: #fff;
    }

    .transaction-circle-status2{
      width: 110px;
      height: 110px;
      border-radius: 50%;
      border: 7px solid #fff;
      background: #F85C4B;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 5000000;
    }

    .transaction-circle-status2 i{
      font-size: 30px;
      color: #fff;
    }

    .transaction-circle-status3{
      width: 110px;
      height: 110px;
      border-radius: 50%;
      border: 7px solid #fff;
      background: #1A4594;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 5000000;
    }

    .transaction-circle-status3 i{
      font-size: 30px;
      color: #fff;
    }

    .transaction-container-detail{
      width: 80%;
      height: 350px;
      background: #fff;
      border-radius: 20px;
      margin-top: -40px;
    }

    .options-back-div{
      width: 100%;
      padding: 20px;
      text-align: left;
    }

    .options-back-div i{
      font-size: 28px;
      color: #3A3A3A;
    }

    .detail-lines{
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
    }

    .detail-lines i:nth-child(1){
      font-size: 18px;
      margin-left: -8px;
      color: #442A7C;
    }

    .detail-lines i:nth-child(3){
      font-size: 18px;
      margin-right: -8px;
      color: #442A7C;
    }

    .detail-lines hr{
      width: 100%;
      border-top: 1px dashed #3A3A3A;
      margin-right: 4px;
      margin-left: 4px;
    }

    .transaction-status-name{
      width: 100%;
      text-align: center;
      padding-bottom: 8px;
    }

    .transaction-status-name h4{
      font-size: 20px;
      font-family: 'Poppins', sans-serif;
      font-weight: 600;
      color: #32A85B;
      margin-bottom: 0;
    }

    .transaction-status-name2{
      width: 100%;
      text-align: center;
      padding-bottom: 8px;
    }

    .transaction-status-name2 h4{
      font-size: 20px;
      font-family: 'Poppins', sans-serif;
      font-weight: 600;
      color: #F85C4B;
      margin-bottom: 0;
    }

    .transaction-status-name3{
      width: 100%;
      text-align: center;
      padding-bottom: 8px;
    }

    .transaction-status-name3 h4{
      font-size: 20px;
      font-family: 'Poppins', sans-serif;
      font-weight: 600;
      color: #1A4594;
      margin-bottom: 0;
    }

    .transaction-company-message{
      width: 100%;
      text-align: center;
      padding: 10px;
    }

    .transaction-company-message h4{
      font-size: 19px;
      font-family: 'Poppins', sans-serif;
      font-weight: 600;
      color: #3A3A3A;
      margin-bottom: 0;
    }

    .transaction-company-message h5{
      font-size: 14px;
      font-family: 'Poppins', sans-serif;
      font-weight: 400;
      color: #3A3A3A;
      padding-top: 5px;
      margin-bottom: 0;
    }

    .boton-send{
      color: #fff;
        background: #32A85B;
        font-size: 15px;
      font-family: 'Poppins', sans-serif;
      padding: 10px 25px;
      border-radius: 7px;
    }

    .boton-send2{
      color: #fff;
        background: #F85C4B;
        font-size: 15px;
      font-family: 'Poppins', sans-serif;
      padding: 10px 25px;
      border-radius: 7px;
    }

    .boton-send2 i{
      margin-right: 5px;
    }

    .boton-send3{
      color: #fff;
        background: #1A4594;
        font-size: 15px;
      font-family: 'Poppins', sans-serif;
      padding: 10px 25px;
      border-radius: 7px;
    }

    .transaction-button{
      width: 100%;
      height: auto;
      padding-top: 35px;
    }

  .options-button{
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 30px;
  }

  .options-button2{
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 30px;
  }

  .fa-times-circle{
    font-size: 100px;
    padding-bottom: 15px;
    color: #EE1818;
  }

  .fa-clock{
    font-size: 100px;
    padding-bottom: 15px;
    color: #003466;
  }

  .fa-whatsapp {
    font-size: 12px !important;
    color: white;
    margin-right: 5px;
  }

  .fa-long-arrow-alt-left{
    font-size: 12px !important;
    color: white;
    margin-right: 5px;
  }

  .aprobed{
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 60px;
    height: auto;
    text-align: center;
  }

  .fa-check-circle {
    font-size: 100px;
    padding-bottom: 15px;
    color: #31DF46;
  }

  .aprobed h3{
    font-size: 18px;
    font-weight: 500;
    color: #2C3E50;
  }

  .aprobed h4{
    font-size: 23px;
    font-weight: 500;
  } 

  .aprobed p{
    font-size: 16px;
    font-weight: 500;
  }	

	.boton-back{
    font-family: Google Sans,Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
    font-weight: 500;
    font-size: 14px;
    letter-spacing: .25px;
    line-height: 16px;
    min-width: 96px;
    padding: 9px 15px;
    text-align: center;
    vertical-align: middle;
    border-radius: 4px;
    box-sizing: border-box;
    border: 1px solid transparent;
    cursor: pointer;
    text-decoration: none;
    color: #fff;
    margin-right: 15px;
  }

  .boton-back2{
    font-family: Google Sans,Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
    font-weight: 500;
    font-size: 16px;
    letter-spacing: .25px;
    line-height: 16px;
    min-width: 96px;
    padding: 12px 25px;
    text-align: center;
    vertical-align: middle;
    border-radius: 4px;
    box-sizing: border-box;
    border: 1px solid transparent;
    cursor: pointer;
    text-decoration: none;
    color: #fff;
  }

  .boton-send{
    font-family: Google Sans,Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
    font-weight: 500;
    font-size: 14px;
    letter-spacing: .25px;
    line-height: 16px;
    min-width: 96px;
    padding: 9px 15px;
    text-align: center;
    vertical-align: middle;
    border-radius: 4px;
    box-sizing: border-box;
    border: 1px solid transparent;
    cursor: pointer;
    text-decoration: none;
    color: #fff;
    background: #31DF46;
  }
	/*h3{
		font-size: 21px !important;
		font-weight: 500;
		margin-bottom: 20px;
		text-align: center !important;
	}*/
	/*p{
		margin-left: 10px;
		margin-right: 10px;
	}*/
	.portadas{
    	width: 100%;
    	height: auto;
  	}  	
  	@supports(object-fit: cover){
	    .portadas{
	      height: 100%;
	      object-fit: cover;
	      object-position: center center;
	    }
  	}
</style>
<script>
import Vue from 'vue'
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css' //Vuesax styles
import axios from 'axios';
  Vue.use(Vuesax, {
    // 
   })
export default {
	data() {
		return {
			reference: this.$route.params.reference,
			url_images:null,
  			portadas: [],
  			url: 'https://back.vinapp.co/api/wompi/get-data-reference/',
  			uri: null,
  			color_letra: null,
  			nameCompanie: null,
  			messageWapp: null,
  			status: 'PENDIENTE',
  			dominio: '',
		}	
	},
	methods:{
		setup(){          
  		axios.get(this.url+this.reference)
  		.then(res => {
  			var self = this;
  			if(res.data.statusCode == 200){  				
  				this.portadas = res.data.store.portadas;  				
  				this.url_images = res.data.url_images; 
  				this.nameCompanie = res.data.store.name_companie; 
  				this.uri = res.data.store.uri; 
  				this.messageWapp = res.data.wapp;
  				switch(res.data.model_wompi.wp_status){
  					case 'APPROVED':
  					this.status = 'APROBADA';
  					break;
  					case 'DECLINED':
  					this.status = 'RECHAZADA';
  					break;
  					case 'VOIDED':
  					this.status = 'ANULADA';
            break;
            case 'ERROR':
            this.status = 'ERROR';
  					break;
  				}
  				this.color_letra = res.data.store.color_letra;
          var body = document.body;     
          setTimeout(function(){ body.classList.add("loaded"); },0);		
  			}
  			})
		    .catch(err => {
		        console.log(err);      
		    });
  		},
	},
	mounted() { 
		this.dominio = window.location.origin+'/';
		this.setup();	
	}
}
</script>